(() => {
  if (window.tcsPawdograph) return;
  const strings = JSON.parse(document.getElementById('tcs-pawdograph-strings').textContent);
  const decode = document.createElement('textarea');
  Object.keys(strings).forEach(key => { decode.innerHTML = strings[key]; strings[key] = decode.value; });
  const eligible = new Set(JSON.parse(document.getElementById('tcs-pawdograph-products').textContent).map(Number));
  const owned = ['Dedicated_Name', 'Personalized_Message_Cedric', 'Personalized_Message', 'Personalization', 'Message choice'];
  const root = window.Shopify?.routes?.root || '/';
  const clean = value => typeof value === 'string' ? value.trim() : '';
  const message = properties => clean(properties.Personalized_Message_Cedric) || clean(properties.Personalized_Message);
  function complete(item) {
    if (!eligible.has(Number(item.product_id))) return true;
    const p = item.properties || {};
    if (p.Personalization === 'No dedication') return p['Message choice'] === 'No message' && !clean(p.Dedicated_Name) && !message(p);
    const name = clean(p.Dedicated_Name);
    if (!name || name.length > 60) return false;
    if (!p.Personalization && !p['Message choice']) return !!message(p) && message(p).length <= 150;
    if (p.Personalization !== 'Dedication') return false;
    return p['Message choice'] === 'No message' ? !message(p) : ['Suggested', 'Custom'].includes(p['Message choice']) && !!message(p) && message(p).length <= 150;
  }
  async function request(path, options) {
    const response = await fetch(root + path, options);
    let data;
    try { data = await response.json(); } catch { throw new Error(strings.network_error); }
    if (!response.ok || data.status) throw new Error(data.description || data.message || strings.network_error);
    return data;
  }
  function error(component, text, control) {
    const box = component.querySelector('[data-pawdograph-error]');
    box.textContent = text;
    box.hidden = !text;
    component.querySelectorAll('[aria-invalid]').forEach(el => el.removeAttribute('aria-invalid'));
    if (control) { control.setAttribute('aria-invalid', 'true'); control.focus(); }
  }
  function update(component) {
    const intent = component.querySelector('[data-dedication-choice]:checked')?.value || '';
    const skip = intent === 'No dedication';
    const personalizing = intent === 'Dedication';
    const name = component.querySelector('[data-dedication]');
    const custom = component.querySelector('[data-custom-message]');
    const choice = component.querySelector('[data-message-choice]:checked')?.value || '';
    component.querySelector('[data-dedication-fields]').hidden = !personalizing;
    name.disabled = !personalizing; name.required = personalizing;
    component.querySelectorAll('[data-message-choice]').forEach(el => { el.disabled = !personalizing; el.required = personalizing; });
    custom.disabled = !personalizing || choice !== 'Custom'; custom.required = personalizing && choice === 'Custom';
    component.querySelector('[data-custom-wrap]').hidden = !personalizing || choice !== 'Custom';
    component.querySelector('[data-message-count]').textContent = `${custom.value.length} / 150`;
    const text = !personalizing ? '' : choice === 'Suggested' ? component.dataset.suggested : choice === 'Custom' ? clean(custom.value) : '';
    component.querySelector('[data-intent]').value = intent;
    component.querySelector('[data-choice-property]').value = skip ? 'No message' : personalizing ? choice : '';
    component.querySelector('[data-message-property]').value = text;
    const summary = component.querySelector('[data-pawdograph-summary]');
    summary.hidden = !skip && !(personalizing && clean(name.value) && choice && (choice !== 'Custom' || clean(custom.value)));
    summary.textContent = skip ? strings.skip_summary : strings.summary.replace('{name}', clean(name.value)).replace('{message}', text || strings.no_message_summary);
  }
  function validate(component) {
    update(component);
    error(component, '');
    if (!component.querySelector('[data-dedication-choice]:checked')) { error(component, strings.intent_error, component.querySelector('[data-dedication-choice]')); return false; }
    if (component.querySelector('[data-no-dedication]').checked) return true;
    const name = component.querySelector('[data-dedication]');
    if (!clean(name.value) || clean(name.value).length > 60) { error(component, strings.name_error, name); return false; }
    const choice = component.querySelector('[data-message-choice]:checked');
    if (!choice) { error(component, strings.choice_error, component.querySelector('[data-message-choice]')); return false; }
    const custom = component.querySelector('[data-custom-message]');
    if (choice.value === 'Custom' && (!clean(custom.value) || clean(custom.value).length > 150)) { error(component, strings.message_error, custom); return false; }
    return true;
  }
  function properties(component, previous = {}) {
    const result = { ...previous };
    owned.forEach(key => delete result[key]);
    const skip = component.querySelector('[data-no-dedication]').checked;
    result.Personalization = skip ? 'No dedication' : 'Dedication';
    result['Message choice'] = component.querySelector('[data-choice-property]').value;
    if (!skip) result.Dedicated_Name = clean(component.querySelector('[data-dedication]').value);
    const text = component.querySelector('[data-message-property]').value;
    if (text) result[component.dataset.messageKey] = text;
    return result;
  }
  function hydrate(component, props) {
    const name = component.querySelector('[data-dedication]');
    const custom = component.querySelector('[data-custom-message]');
    name.value = props.Dedicated_Name || '';
    const intent = props.Personalization === 'No dedication' ? 'No dedication' : (clean(props.Dedicated_Name) || message(props) || props.Personalization === 'Dedication') ? 'Dedication' : '';
    component.querySelectorAll('[data-dedication-choice]').forEach(el => el.checked = el.value === intent);
    let choice = props['Message choice'];
    const text = message(props);
    if (!choice && text) choice = text === component.dataset.suggested ? 'Suggested' : 'Custom';
    if (choice === 'Suggested' && text !== component.dataset.suggested) choice = 'Custom';
    custom.value = text;
    component.querySelectorAll('[data-message-choice]').forEach(el => el.checked = el.value === choice);
    update(component);
  }
  function suppressOwnedAppFields(component) {
    const form = component.closest('form');
    if (!form) return;
    form.querySelectorAll('input[name^="properties["],textarea[name^="properties["],select[name^="properties["]').forEach(input => {
      const key = input.name.slice(11, -1);
      if (owned.includes(key) && !component.contains(input)) {
        input.disabled = true;
        const group = input.closest('.gpo-element, .gpo-form__group, .gpo-field');
        if (group) group.hidden = true;
      }
    });
  }
  class Pawdograph extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.addEventListener('input', () => { update(this); error(this, ''); });
      this.addEventListener('change', () => { update(this); error(this, ''); });
      update(this);
      suppressOwnedAppFields(this);
    }
  }
  customElements.define('tcs-pawdograph', Pawdograph);
  let dialog, opener, activeLine, loading = false, dialogVersion = 0;
  const drafts = new Map();
  const productPages = new Map();
  function ensureDialog() {
    if (dialog) return dialog;
    dialog = document.createElement('dialog');
    dialog.className = 'tcs-pawdograph-dialog color-scheme-1 gradient';
    dialog.setAttribute('aria-labelledby', 'tcs-pawdograph-dialog-title');
    dialog.innerHTML = '<button type="button" class="button button--secondary tcs-pawdograph-dialog__close" data-pawdograph-close></button><h2 id="tcs-pawdograph-dialog-title" class="h3"></h2><div data-pawdograph-content></div>';
    const close = dialog.querySelector('[data-pawdograph-close]'); close.setAttribute('aria-label', strings.close); close.innerHTML = '<svg viewBox="0 0 24 24" width="24" height="24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>';
    dialog.querySelector('[data-pawdograph-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', e => { if (e.target === dialog) { const r = dialog.getBoundingClientRect(); if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) dialog.close(); } });
    dialog.addEventListener('keydown', e => {
      if (e.key !== 'Tab') return;
      const controls = [...dialog.querySelectorAll('button, input, textarea, select, a[href], [tabindex]')].filter(el => !el.disabled && el.tabIndex >= 0 && el.getClientRects().length);
      const first = controls[0], last = controls.at(-1);
      if (e.shiftKey && (document.activeElement === first || !dialog.contains(document.activeElement))) { e.preventDefault(); last?.focus(); }
      else if (!e.shiftKey && (document.activeElement === last || !dialog.contains(document.activeElement))) { e.preventDefault(); first?.focus(); }
    });
    dialog.addEventListener('close', () => {
      const component = dialog.querySelector('[data-pawdograph]');
      if (component) drafts.set(activeLine?.key || component.dataset.productUrl, draft(component));
      opener?.focus();
    });
    document.body.append(dialog);
    return dialog;
  }
  function draft(component) {
    return { name: component.querySelector('[data-dedication]').value, custom: component.querySelector('[data-custom-message]').value, choice: component.querySelector('[data-message-choice]:checked')?.value, intent: component.querySelector('[data-dedication-choice]:checked')?.value || '' };
  }
  function restore(component, value) {
    component.querySelector('[data-dedication]').value = value.name;
    component.querySelector('[data-custom-message]').value = value.custom;
    component.querySelectorAll('[data-dedication-choice]').forEach(el => el.checked = el.value === value.intent);
    component.querySelectorAll('[data-message-choice]').forEach(el => el.checked = el.value === value.choice);
    update(component);
  }
  async function open(button) {
    if (loading) return;
    loading = true; opener = button; activeLine = null; const version = ++dialogVersion;
    ensureDialog();
    dialog.querySelector('#tcs-pawdograph-dialog-title').textContent = strings.personalize_add;
    const content = dialog.querySelector('[data-pawdograph-content]');
    content.replaceChildren();
    const status = document.createElement('p'); status.textContent = strings.loading; status.setAttribute('role', 'status'); content.append(status);
    const fallback = document.createElement('a'); fallback.href = button.dataset.productUrl; fallback.textContent = strings.fallback; fallback.dataset.pawdographFallback = ''; content.append(fallback);
    dialog.showModal();
    try {
      if (button.dataset.lineKey) {
        const cart = await request('cart.js');
        activeLine = cart.items.find(item => item.key === button.dataset.lineKey);
        if (!activeLine) throw new Error(strings.stale);
      }
      const url = new URL(button.dataset.productUrl, location.origin);
      if (window.Shopify?.theme?.role !== 'main' && window.Shopify?.theme?.id) url.searchParams.set('preview_theme_id', window.Shopify.theme.id);
      if (activeLine) url.searchParams.set('variant', activeLine.variant_id);
      let html = productPages.get(url.href);
      if (!html) { const response = await fetch(url, { signal: AbortSignal.timeout(15000) }); if (!response.ok) throw new Error(strings.load_error); html = await response.text(); }
      const documentCopy = new DOMParser().parseFromString(html, 'text/html');
      const source = documentCopy.querySelector('[data-pawdograph]');
      if (!source) throw new Error(strings.load_error);
      productPages.set(url.href, html);
      if (!dialog.open || version !== dialogVersion) return;
      const component = source.cloneNode(true);
      component.querySelectorAll('[id]').forEach(el => {
        const old = el.id; el.id = 'dialog-' + old;
        component.querySelectorAll('[for]').forEach(label => { if (label.htmlFor === old) label.htmlFor = el.id; });
        component.querySelectorAll('[aria-describedby]').forEach(control => { control.setAttribute('aria-describedby', control.getAttribute('aria-describedby').split(' ').map(id => id === old ? el.id : id).join(' ')); });
      });
      component.querySelectorAll('[data-message-choice],[data-dedication-choice]').forEach(el => el.name += '-dialog');
      dialog.querySelector('#tcs-pawdograph-dialog-title').textContent = activeLine ? strings.edit : strings.dialog_heading;
      content.replaceChildren();
      const overview = document.createElement('div'); overview.className = 'tcs-pawdograph-dialog__product';
      if (component.dataset.image) { const img = document.createElement('img'); img.src = component.dataset.image; img.alt = component.dataset.title; img.width = 88; img.height = 88; img.className = 'tcs-pawdograph-dialog__image'; overview.append(img); }
      const details = document.createElement('div');
      const title = document.createElement('p'); title.className = 'tcs-pawdograph-dialog__product-title'; title.textContent = component.dataset.title;
      const price = document.createElement('p'); price.className = 'tcs-pawdograph-dialog__price'; price.textContent = component.dataset.price; details.append(title, price); overview.append(details); content.append(overview);
      const form = document.createElement('form'); form.noValidate = true; form.dataset.pawdographDialogForm = ''; form.append(component);
      source.closest('form')?.querySelectorAll('input[type=hidden][name^="properties["]').forEach(input => { if (!owned.includes(input.name.slice(11, -1)) && !input.disabled) { const copy = input.cloneNode(true); copy.removeAttribute('id'); copy.removeAttribute('form'); form.append(copy); } });
      if (!activeLine) {
        const sourceForm = source.closest('form');
        const quantitySource = documentCopy.querySelector(`input[name="quantity"][form="${CSS.escape(sourceForm?.id || '')}"]`) || sourceForm?.querySelector('input[name="quantity"]');
        const purchase = document.createElement('div'); purchase.className = 'tcs-pawdograph-dialog__quantity';
        const label = document.createElement('label'); label.textContent = strings.quantity; label.htmlFor = 'tcs-pawdograph-quantity'; purchase.append(label);
        const stepper = document.createElement('div'); stepper.className = 'quantity tcs-pawdograph-quantity'; stepper.setAttribute('role', 'group'); stepper.setAttribute('aria-label', strings.quantity);
        for (const direction of ['minus', 'plus']) {
          const button = document.createElement('button'); button.type = 'button'; button.name = direction; button.className = 'quantity__button'; button.setAttribute('aria-label', direction === 'minus' ? strings.decrease_quantity : strings.increase_quantity);
          button.innerHTML = '<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true"><path d="M5 12h14' + (direction === 'plus' ? 'M12 5v14' : '') + '" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>';
          stepper.append(button);
          if (direction === 'minus') {
            const quantity = document.createElement('input'); quantity.type = 'number'; quantity.name = 'quantity'; quantity.id = label.htmlFor; quantity.setAttribute('aria-label', strings.quantity); quantity.value = quantitySource?.min || '1'; quantity.min = quantitySource?.min || '1'; quantity.step = quantitySource?.step || '1'; if (quantitySource?.max) quantity.max = quantitySource.max; quantity.className = 'quantity__input'; quantity.inputMode = 'numeric'; quantity.required = true; stepper.append(quantity);
          }
        }
        const input = stepper.querySelector('input');
        const syncQuantity = () => { stepper.querySelector('[name=minus]').disabled = Number(input.value) <= Number(input.min); stepper.querySelector('[name=plus]').disabled = !!input.max && Number(input.value) >= Number(input.max); };
        stepper.querySelectorAll('button').forEach(button => button.addEventListener('click', () => { button.name === 'plus' ? input.stepUp() : input.stepDown(); input.dispatchEvent(new Event('change', { bubbles: true })); }));
        input.addEventListener('input', syncQuantity); input.addEventListener('change', syncQuantity); syncQuantity();
        purchase.append(stepper);
        const copies = document.createElement('p'); copies.className = 'caption tcs-pawdograph-dialog__copies'; copies.textContent = strings.copies; purchase.append(copies); form.append(purchase);
      }
      const submit = document.createElement('button'); submit.type = 'submit'; submit.className = 'button button--full-width'; submit.textContent = activeLine ? strings.save : strings.add_to_cart;
      submit.disabled = !activeLine && component.dataset.available !== 'true';
      const actions = document.createElement('div'); actions.className = 'tcs-pawdograph-dialog__actions'; actions.append(submit, fallback); form.append(actions); content.append(form);
      if (activeLine) hydrate(component, activeLine.properties || {});
      const saved = drafts.get(activeLine?.key || component.dataset.productUrl); if (saved) restore(component, saved);
      (component.querySelector('[data-dedication-choice]:checked') || component.querySelector('[data-dedication-choice]')).focus();
    } catch (e) { status.textContent = strings.load_error; if (!content.contains(status)) content.replaceChildren(status, fallback); fallback.focus(); }
    finally { loading = false; }
  }
  function sectionIds() {
    return [...new Set(['cart-drawer', 'cart-icon-bubble', document.getElementById('main-cart-items')?.dataset.id, document.getElementById('main-cart-footer')?.dataset.id].filter(Boolean))];
  }
  async function refresh(cart) {
    const drawer = document.querySelector('cart-drawer');
    if (drawer && !document.getElementById('main-cart-items')) {
      if (!cart.sections?.['cart-drawer']) throw new Error(strings.network_error);
      drawer.renderContents(cart);
    } else {
      for (const id of ['main-cart-items', 'main-cart-footer', 'cart-icon-bubble']) {
        const target = document.getElementById(id);
        if (!target) continue;
        const key = target.dataset.id || id;
        const html = cart.sections?.[key];
        if (!html) throw new Error(strings.network_error);
        const parsed = new DOMParser().parseFromString(html, 'text/html');
        const source = parsed.getElementById(id) || (id === 'cart-icon-bubble' ? parsed.querySelector('.shopify-section') : null);
        if (!source) throw new Error(strings.network_error);
        target.replaceChildren(...source.childNodes);
      }
      if (drawer && cart.sections?.['cart-drawer']) {
        const parsed = new DOMParser().parseFromString(cart.sections['cart-drawer'], 'text/html');
        const target = drawer.querySelector('.drawer__inner');
        const source = parsed.querySelector('.drawer__inner');
        if (target && source) { target.replaceChildren(...source.childNodes); drawer.querySelector('#CartDrawer-Overlay')?.addEventListener('click', () => drawer.close()); }
      }
    }
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') await publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: cart });
    document.querySelector('[data-pawdograph-cart-error]')?.remove();
    scheduleCartCheck();
  }
  async function submit(form, component) {
    if (form.dataset.pawdographBusy === 'true' || !validate(component)) return;
    const quantity = form.querySelector('[name=quantity]') || document.querySelector(`[name=quantity][form="${CSS.escape(form.id)}"]`);
    if (quantity && !quantity.checkValidity()) { quantity.reportValidity(); return; }
    const editingLine = form.hasAttribute('data-pawdograph-dialog-form') ? activeLine : null;
    const version = dialogVersion;
    let saved = false;
    form.dataset.pawdographBusy = 'true';
    const buttons = [...form.querySelectorAll('[type=submit]')]; const labels = buttons.map(button => button.textContent); buttons.forEach(button => { button.setAttribute('aria-disabled', 'true'); if (form.hasAttribute('data-pawdograph-dialog-form')) button.textContent = editingLine ? strings.saving : strings.adding; });
    try {
      let data;
      if (editingLine) {
        const cart = await request('cart.js');
        const current = cart.items.find(item => item.key === editingLine.key);
        if (!current) throw new Error(strings.stale);
        data = await request('cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: current.key, quantity: current.quantity, properties: properties(component, current.properties || {}), sections: sectionIds(), sections_url: root + 'cart' }) });
      } else {
        suppressOwnedAppFields(component);
        const body = new FormData(form);
        owned.forEach(key => body.delete(`properties[${key}]`));
        const props = properties(component); Object.entries(props).forEach(([key,value]) => body.append(`properties[${key}]`, value));
        component.querySelectorAll('[data-message-choice],[data-dedication-choice]').forEach(input => body.delete(input.name));
        if (!body.get('id')) body.set('id', component.dataset.variantId);
        body.set('quantity', quantity?.value || body.get('quantity') || '1');
        body.set('sections', sectionIds().join(',')); body.set('sections_url', root + 'cart');
        data = await request('cart/add.js', { method: 'POST', body });
      }
      saved = true;
      if (dialog?.contains(component) && version === dialogVersion) { const draftKey = editingLine?.key || component.dataset.productUrl; dialog.close(); drafts.delete(draftKey); }
      else {
        const summary = component.querySelector('[data-pawdograph-summary]'); summary.textContent = strings.added + ' · ' + summary.textContent;
      }
      await refresh(data);
      if (!document.querySelector('cart-drawer')) location.assign(root + 'cart');
    } catch (e) { if (saved) { location.assign(root + 'cart'); } else { error(component, e.message || strings.network_error); } }
    finally { form.dataset.pawdographBusy = 'false'; buttons.forEach((button,index) => { button.removeAttribute('aria-disabled'); if (form.hasAttribute('data-pawdograph-dialog-form')) button.textContent = labels[index]; }); }
  }
  let checkoutPending = false, cartTimer, checkoutTicket = null;
  async function checkout(target, form) {
    if (checkoutPending) return;
    checkoutPending = true;
    try {
      const cart = await request('cart.js');
      const missing = cart.items.filter(item => !complete(item));
      if (missing.length) {
        showCartError(strings.cart_error);
        const edit = [...document.querySelectorAll('[data-pawdograph-edit]')].find(el => el.dataset.lineKey === missing[0].key);
        if (edit) { edit.focus(); edit.scrollIntoView({ block: 'center' }); }
        else location.assign(root + 'cart');
        return;
      }
      checkoutTicket = target;
      if (target.matches('a')) target.click();
      else if (form) form.requestSubmit(target);
      else location.assign(root + 'checkout');
    } catch { showCartError(strings.cart_unavailable); }
    finally { checkoutPending = false; }
  }
  function showCartError(text) {
    let box = document.querySelector('[data-pawdograph-cart-error]');
    if (!box) { box = document.createElement('p'); box.dataset.pawdographCartError = ''; box.setAttribute('role','alert'); (document.querySelector('main .cart__ctas') || document.querySelector('cart-drawer .cart__ctas') || document.querySelector('.drawer__footer') || document.querySelector('main')).prepend(box); }
    box.textContent = text;
  }
  function scheduleCartCheck() {
    clearTimeout(cartTimer); cartTimer = setTimeout(() => {
      document.querySelectorAll('[data-pawdograph]').forEach(suppressOwnedAppFields);
      const incomplete = [...document.querySelectorAll('[data-pawdograph-line]')].some(node => {
        try { const item = JSON.parse(node.textContent); const valid = complete(item); const button = node.parentElement.querySelector('[data-pawdograph-edit]'); if (button) { const text = valid ? strings.edit : strings.complete; if (button.textContent.trim() !== text) button.textContent = text; button.dataset.pawdographComplete = String(valid); } return !valid; } catch { return true; }
      });
      document.querySelectorAll('.cart__dynamic-checkout-buttons, .cart__dynamic-checkout-buttons.additional-checkout-buttons').forEach(node => { node.hidden = !!document.querySelector('[data-pawdograph-line]'); });
    }, 80);
  }
  document.addEventListener('click', e => {
    const button = e.target.closest('[data-pawdograph-open],[data-pawdograph-edit]');
    if (button && !button.disabled && button.getAttribute('aria-disabled') !== 'true') { e.preventDefault(); e.stopImmediatePropagation(); open(button); return; }
    const target = e.target.closest('[name=checkout], a[href$="/checkout"],a[href*="/checkout?"]');
    if (target) {
      if (checkoutTicket === target) { checkoutTicket = null; return; }
      e.preventDefault(); e.stopImmediatePropagation(); checkout(target, target.form);
    }
  }, true);
  document.addEventListener('submit', e => {
    const component = e.target.querySelector('[data-pawdograph]');
    if (component) { e.preventDefault(); e.stopImmediatePropagation(); submit(e.target, component); return; }
    if (e.submitter?.name === 'checkout') {
      if (checkoutTicket === e.submitter) { checkoutTicket = null; return; }
      e.preventDefault(); e.stopImmediatePropagation(); checkout(e.submitter, e.target);
    }
  }, true);
  new MutationObserver(scheduleCartCheck).observe(document.body, { childList: true, subtree: true });
  scheduleCartCheck();
  window.tcsPawdograph = { complete, validate, properties };
})();
